import React from 'react'
import styled from 'styled-components'
import { Icon } from '@iconify/react';
import timesSolid from '@iconify/icons-la/times-solid';
import connectionIcon from '@iconify/icons-icomoon-free/connection';
import disconnectedSolid from '@iconify/icons-clarity/disconnected-solid';
import batteryHalf from '@iconify/icons-bi/battery-half';
import lightningFill from '@iconify/icons-bi/lightning-fill';
import { Toggle } from './Toggle';
import { colour_lookup } from '../../common/Colours'

export const SettingsContainer = styled.div<{displayContainer: boolean; features: any; fullscreen: boolean;}>`
  display: ${props => props.displayContainer? 'block' : 'none'};
  width: 300px;
  background: #FFF;
  position: absolute;
  top: ${props => props.features.sub.menu && !props.fullscreen? '130px' : '70px'};
  left: ${props => props.features.sub.menu && !props.fullscreen? '20px' : '10px'};
  border-radius: 10px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
`;

const Close = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 10px;
  cursor: pointer;
  color: #555;
  
  &:hover {
    color: #333;
  }
`;

export const SettingsOpen = styled.div<{ features: any; fullscreen: Boolean; }>`
  width: 50px;
  height: 50px;
  background: rgba(255,255,255,0.7);
  border-radius: 25px;
  position: absolute;
  left: 3rem;
  top: ${props => props.features.sub.menu && !props.fullscreen? '70px' : '10px'};
  padding: 5px;
  cursor: pointer;
  color: #555;
  // border: 1px solid #ddd;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  
  &:hover {
    color: #333;
    border: 1px solid #ccc;
  }
  
  div {
    font-size: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const Heading = styled.h1`
  color: #444;
  margin: 10px 10px 10px 0px;
  font-size: 20px;
  width: 100%;
  text-align: center;
`;

const Block = styled.div`
  margin: 20px;
`;

const Setting = styled.div`
  margin: 10px;
  display: flex;
  justify-content: space-between;
`;

const SettingName = styled.div`
  color: #555;
  font-size: 18px;
  margin-bottom: 5px;
`;

const SettingsToggle = styled.div`

`;

const Variation = styled.div`
  margin: 2px;
  display: flex;
  justify-content: start;
`;

const VariationIcon = styled.div`
  width: 20px;
`;

const VariationText = styled.div`
  font-size: 16px;
  color: #555;
  margin: 0 10px;
  padding-top: 0px;
  line-height: 22px;
`;

export const Settings = ({ settings, setSettings, features, fullscreen }: { settings: any, setSettings: any; features: any; fullscreen: boolean; }) => {
  
  return (
    <SettingsContainer displayContainer={settings.display} features={features} fullscreen={fullscreen} style={{ left : '3rem' }}>
      <Close onClick={() => {setSettings({ ...settings, display: false })}}><Icon width='25px' height='25px' icon={timesSolid} /></Close>
      <Heading>Map Details</Heading>
      <Block>
        <Setting>
          <SettingName>Connectivity</SettingName>
          {settings.editable?
            <SettingsToggle>
              <Toggle selected={true}/>
            </SettingsToggle>
          : null}
        </Setting>
        <Variation>
          <VariationIcon><Icon color={colour_lookup('green')} width='20px' height='20px' icon={connectionIcon}/></VariationIcon>
          <VariationText>Online</VariationText>
        </Variation>
        <Variation>
          <VariationIcon><Icon color={colour_lookup('blue')} width='20px' height='20px' icon={connectionIcon}/></VariationIcon>
          <VariationText>Power Saving</VariationText>
        </Variation>
        <Variation>
          <VariationIcon><Icon color={colour_lookup('amber')} width='20px' height='20px' icon={connectionIcon}/></VariationIcon>
          <VariationText>Unbuffering/Delayed</VariationText>
        </Variation>
        <Variation>
          <VariationIcon><Icon color={colour_lookup('red')} width='20px' height='20px' icon={disconnectedSolid}/></VariationIcon>
          <VariationText>Offline</VariationText>
        </Variation>
        <Variation>
          <VariationIcon><Icon color={colour_lookup('grey')} width='20px' height='20px' icon={disconnectedSolid}/></VariationIcon>
          <VariationText>Not Measuring</VariationText>
        </Variation>
      </Block>
      <Block>
        <Setting>
          <SettingName>Exceedances</SettingName>
          {settings.editable?
            <SettingsToggle>
              <Toggle selected={true}/>
            </SettingsToggle>
          : null}
        </Setting>
        <Variation>
          <VariationIcon>
            <svg width='20px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
              <g>
                <circle cx='15' cy='15' r='15' fill='#fff'/>
                <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup('green')}/>
                <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill={colour_lookup('green')}/>
              </g>
            </svg>
          </VariationIcon>
          <VariationText>No exceedances in period</VariationText>
        </Variation>
        <Variation>
          <VariationIcon>
            <svg width='20px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
              <g>
                <circle cx='15' cy='15' r='15' fill='#fff'/>
                <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup('red')}/>
                <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill={colour_lookup('green')}/>
              </g>
            </svg>
          </VariationIcon>
          <VariationText>Exceedances recorded previously in period</VariationText>
        </Variation>
        <Variation>
          <VariationIcon>
            <svg width='20px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
              <g>
                <circle cx='15' cy='15' r='15' fill='#fff'/>
                <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup('red')}/>
                <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill={colour_lookup('red')}/>
              </g>
            </svg>
          </VariationIcon>
          <VariationText>Limit currently being exceeded</VariationText>
        </Variation>
      </Block>
      <Block>
        <Setting>
          <SettingName>Battery</SettingName>
          {settings.editable?
            <SettingsToggle>
              <Toggle selected={true}/>
            </SettingsToggle>
          : null}
        </Setting>
        <Variation>
          <VariationIcon>
            <svg width='20px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
              <circle cx='15' cy='15' r='15' fill='#fff'/>
              <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup('green')}/>
              <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill='#FFF'/>
              <g transform='translate(7.5,7.5)'>
                <Icon color={colour_lookup('green')} width='15px' height='15px' icon={lightningFill}/>
              </g>
            </svg>
          </VariationIcon>
          <VariationText>Charging, and voltage {'>'} threshold</VariationText>
        </Variation>
        <Variation>
          <VariationIcon>
            <svg width='20px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
              <circle cx='15' cy='15' r='15' fill='#fff'/>
              <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup('amber')}/>
              <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill='#FFF'/>
              <g transform='translate(7.5,7.5)'>
                <Icon color={colour_lookup('amber')} width='15px' height='15px' icon={lightningFill}/>
              </g>
            </svg>
          </VariationIcon>
          <VariationText>Charging, and voltage {'<'} threshold</VariationText>
        </Variation>
        <Variation>
          <VariationIcon>
            <svg width='20px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
              <circle cx='15' cy='15' r='15' fill='#fff'/>
              <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup('red')}/>
              <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill='#FFF'/>
              <g transform='translate(7.5,7.5)'>
                <Icon color={colour_lookup('red')} width='15px' height='15px' icon={lightningFill}/>
              </g>
            </svg>
          </VariationIcon>
          <VariationText>Not Charging</VariationText>
        </Variation>
      </Block>
    </SettingsContainer>
  )
}